import * as React from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Button,
  TextField,
} from "@mui/material";
import { visuallyHidden } from "@mui/utils";
// import viewIcon from "../../../assets/DigitalMarketing/image/visibility.svg";
// import editIcon from "../../../assets/DigitalMarketing/image/edit.svg";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import SearchBox from "../../../Component/DigitalMarketing/SearchBox";
import Pagination from "../../../Component/DigitalMarketing/Pagination";
import { formatWord } from "../Utils/utils";
import eye from "../../../assets/DigitalMarketing/image/eye.svg";

// Define table headers based on the image
const headCells = [
  { id: "sno", numeric: false, label: "S.no" },
  { id: "patientName", numeric: false, label: "Patient Name" },
  { id: "phone1", numeric: false, label: "Mobile Number" },
  { id: "consultationType", numeric: false, label: "Consultation Type" },
  { id: "appointmentDate", numeric: false, label: "Appointment Date" },
  { id: "appointmentTime", numeric: false, label: "Appointment Time" },
   { id: "paymentStatus", numeric: false, label: "Payment Status" },
  { id: "status", numeric: false, label: "Status" },
  { id: "action", numeric: false, label: "Action" },
];

const DashTable = (props: any) => {
  const { data } = props;
  const [order, setOrder] = React.useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = React.useState<string>("sno");
  const [searchQuery, setSearchQuery] = React.useState("");
  const navigate = useNavigate();

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: string
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
  };

  const getStatusStyles = (status: string) => {
    switch (status?.toLowerCase()) {
      case "scheduled":
        return { backgroundColor: "#FFC107" }; // Yellow with white text
      case "rescheduled":
        return { backgroundColor: "#FFC107" };
      case "completed":
        return { backgroundColor: "#28A745" };
      case "canceled":
        return { backgroundColor: "red", color: "white" }; // Green with white text
      default:
        return { backgroundColor: "#6C757D" }; // Default: Gray with white text
    }
  };

  console.log(data);

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Paper sx={{ width: "100%", mb: 2 }}>
          <TableContainer>
            <Table sx={{ minWidth: 800 }} aria-labelledby="tableTitle">
              <TableHead>
                <TableRow>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align="left"
                      sortDirection={orderBy === headCell.id ? order : false}
                    >
                      <TableSortLabel
                        active={orderBy === headCell.id}
                        direction={orderBy === headCell.id ? order : "asc"}
                        onClick={(event) =>
                          handleRequestSort(event, headCell.id)
                        }
                      >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                          <Box component="span" sx={visuallyHidden}>
                            {order === "desc"
                              ? "sorted descending"
                              : "sorted ascending"}
                          </Box>
                        ) : null}
                      </TableSortLabel>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data?.map((row, index) => (
                  <TableRow key={row.id}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{row.customerName}</TableCell>
                    <TableCell>{row?.phone1}</TableCell>
                    <TableCell
                      style={{
                        color:
                          row.appointmentType === "in-Person"
                            ? "#F33B72"
                            : "#1877F2",
                      }}
                    >
                      {formatWord(row.appointmentType)}
                    </TableCell>
                    <TableCell>{row.appointmentDate}</TableCell>
                    <TableCell>{row.appointmentTime}</TableCell>
                    <TableCell>{row?.paymentStatus}</TableCell>
                    <TableCell>
                      <span
                        style={{
                          padding: "0.3rem 0.6rem",
                          borderRadius: "8px",
                          ...getStatusStyles(row.status),
                        }}
                      >
                        {formatWord(row.status)}
                      </span>
                    </TableCell>
                    <TableCell>
                      <img
                        src={eye}
                        alt="View"
                        className="delete-icon cursor action-icon ms-2"
                        style={{ cursor: "pointer", marginRight: 8 }}
                        onClick={() =>
                          navigate(
                            `/patient-list/patient-details/${row.customersId}`,
                            {
                              state: {
                                consultantId: row.consultantId,
                                appointmentId: row.appointmentId,
                              },
                            }
                          )
                        }
                      />
                      {/* <img
                        // src={editIcon}
                        alt="Edit"
                        style={{ cursor: "pointer" }}
                        onClick={() => console.log("Edit action for", row.customersId)}
                      /> */}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Box>
    </>
  );
};

export default DashTable;
